module.exports = __webpack_public_path__ + "img/stock1.d225eb9f.png";